declare global {
  interface Window {
    ENV_APP_URI: string;
    ENV_GRAPHQL_URI: string;
    ENV_LLM_URI: string;
    ENV_AUTH_URI: string;
    ENV_REST_URI: string;
    ENV_CLIENT_ID: string;
    ENV_ADMIN_APP_URI: string;
    ENV_ACCOUNT_APP_URI: string;
    ENV_INSIGHTS_APP_URI: string;
    ENV_DEVELOPER_APP_URI: string;
    ENV_COMMISSIONING_APP_URI: string;
    ENV_APPLICATIONINSIGHTS_CONNECTION_STRING: string;
    ENV_IS_TEST: boolean;
  }
}

export const APP_URI = window.ENV_APP_URI;
export const GRAPHQL_URI = window.ENV_GRAPHQL_URI;
export const LLM_URI = window.ENV_LLM_URI;
export const AUTH_URI = window.ENV_AUTH_URI;
export const REST_URI = window.ENV_REST_URI;
export const CLIENT_ID = window.ENV_CLIENT_ID;
export const ADMIN_APP_URI = window.ENV_ADMIN_APP_URI;
export const ACCOUNT_APP_URI = window.ENV_ACCOUNT_APP_URI;
export const INSIGHTS_APP_URI = window.ENV_INSIGHTS_APP_URI;
export const DEVELOPER_APP_URI = window.ENV_DEVELOPER_APP_URI;
export const COMMISSIONING_APP_URI = window.ENV_COMMISSIONING_APP_URI;
export const APPLICATIONINSIGHTS_CONNECTION_STRING =
  window.ENV_APPLICATIONINSIGHTS_CONNECTION_STRING;
export const IS_TEST = window.ENV_IS_TEST;

export const IS_AI_CHAT_ENABLED = false;
